import { observable } from 'mobx';

/**
 * Model for UI state. This is where all individual properties
 * related to the UI that can change as the application is used
 * are defined.
 */
export class UIModel {

    // which nav item is active
    @observable public stage:EUnwrapStage;

    constructor(
        stage: EUnwrapStage) {

        this.stage = stage;
    };
}

/**
 * State of unwrapping
 */
export enum EUnwrapStage {
    Identify = "identify", // identify user
    Puzzle = "puzzle", // do puzzle
    Complete = "complete" // completed
}